import { Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { FeatureFlagService } from '@examdojo/core/feature-flag';
import { HomeworkActivityQuery, HomeworkActivityService } from '@examdojo/homework';
import { ExamDojoFeatureFlag, ExamdojoFeatureFlags } from '@examdojo/models/feature-flag';
import { SolutionCaptureQueryParam } from '@examdojo/solution';
import { filter, first, switchMap, tap } from 'rxjs';
import { HomeworkActivityDialogService } from '../dialog/homework-activity-dialog.service';

@Injectable()
export class SolutionCaptureHomeworkDialogEffectService {
  constructor(
    private readonly route: ActivatedRoute,
    private readonly homeworkActivityQuery: HomeworkActivityQuery,
    private readonly homeworkActivityService: HomeworkActivityService,
    private readonly homeworkActivityDialogService: HomeworkActivityDialogService,
    private readonly featureFlagService: FeatureFlagService<ExamdojoFeatureFlags>,
  ) {
    if (this.featureFlagService.get(ExamDojoFeatureFlag.Classes)) {
      this.route.queryParamMap
        .pipe(
          filter((params) => params.get(SolutionCaptureQueryParam) === 'true'),
          switchMap(() => this.homeworkActivityQuery.ongoingActivity$.pipe(filter(Boolean), first())),
          filter(() => !this.homeworkActivityDialogService.isOpen()),
          tap((activity) => {
            this.homeworkActivityService.setActive(activity.id);
            this.homeworkActivityDialogService.openDialog();
          }),
          takeUntilDestroyed(),
        )
        .subscribe();
    }
  }
}
